import type { MenuItem } from '../components/AccountMenu/types';

type AccountMenuConfig = {
    items: Array<MenuItem>;
};

export function accountMenuConfig(items: Array<MenuItem>): AccountMenuConfig {
    return {
        items,
    };
}
